import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = {
  key: 0,
  class: "mr-8"
}
const _hoisted_4 = { class: "grey--text mr-2" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "grey--text mr-2" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "grey--text mr-2" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "grey--text mr-2" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = {
  key: 0,
  class: "d-inline pl-6"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "grey--text mr-2" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = {
  key: 0,
  class: "d-inline pl-6"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "grey--text mr-2" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = {
  key: 0,
  class: "d-inline pl-6"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "d-inline pl-6"
}
const _hoisted_26 = {
  key: 1,
  class: "d-inline pl-6"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "d-flex align-center" }
const _hoisted_29 = { class: "d-flex flex-column align-center" }
const _hoisted_30 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_31 = { class: "ml-3" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_35 = { class: "d-flex align-center" }
const _hoisted_36 = { class: "d-flex flex-column align-center" }
const _hoisted_37 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_38 = { class: "ml-3" }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_42 = { class: "d-flex align-center" }
const _hoisted_43 = { class: "d-flex flex-column align-center" }
const _hoisted_44 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_45 = { class: "ml-3" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_49 = { class: "d-flex align-center" }
const _hoisted_50 = { class: "d-flex flex-column align-center" }
const _hoisted_51 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_52 = { class: "ml-3" }
const _hoisted_53 = { key: 1 }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_56 = { class: "d-flex align-center" }
const _hoisted_57 = { class: "d-flex flex-column align-center" }
const _hoisted_58 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_59 = { class: "ml-3" }
const _hoisted_60 = { key: 1 }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_63 = { class: "d-flex align-center" }
const _hoisted_64 = { class: "d-flex flex-column align-center" }
const _hoisted_65 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_66 = { class: "ml-3" }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = { key: 0 }
const _hoisted_69 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_70 = { class: "d-flex align-center" }
const _hoisted_71 = { class: "d-flex flex-column align-center" }
const _hoisted_72 = {
  class: "d-flex",
  style: {"position":"relative"}
}
const _hoisted_73 = { class: "ml-3" }
const _hoisted_74 = { key: 1 }
const _hoisted_75 = { class: "d-flex" }
const _hoisted_76 = { class: "align-center justify-center pa-15" }
const _hoisted_77 = { class: "d-flex align-center justify-center mb-5" }
const _hoisted_78 = { class: "d-flex align-center justify-center mb-5" }
const _hoisted_79 = { class: "d-flex align-baseline" }
const _hoisted_80 = { class: "d-flex align-center justify-center mb-5" }
const _hoisted_81 = { class: "d-flex align-baseline" }
const _hoisted_82 = { class: "d-flex align-baseline mt-4" }
const _hoisted_83 = {
  key: 0,
  class: "d-flex align-center justify-center mb-5"
}
const _hoisted_84 = { class: "ml-4" }
const _hoisted_85 = { class: "ml-4" }
const _hoisted_86 = {
  key: 0,
  class: "d-flex align-center justify-center mb-5"
}
const _hoisted_87 = { class: "ml-4" }
const _hoisted_88 = { class: "ml-4" }
const _hoisted_89 = { class: "d-flex align-baseline" }
const _hoisted_90 = {
  key: 0,
  class: "d-flex align-center justify-center"
}
const _hoisted_91 = { class: "ml-4" }
const _hoisted_92 = {
  key: 1,
  class: "d-flex align-center justify-center mb-5"
}
const _hoisted_93 = { class: "ml-4" }
const _hoisted_94 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_95 = {
  key: 1,
  class: "ml-4"
}
const _hoisted_96 = { class: "d-flex align-baseline" }
const _hoisted_97 = { class: "d-flex align-baseline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_time_picker = _resolveComponent("v-time-picker")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_btn, {
        color: "grey",
        variant: "text",
        to: "/dailyreport/child"
      }, {
        default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
          _createTextVNode(" 一覧へ ", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.diary)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(_ctx.diary.child.lastName) + " " + _toDisplayString(_ctx.diary.child.firstName), 1))
          : _createCommentVNode("", true),
        _createElementVNode("h3", null, _toDisplayString(_ctx.date), 1),
        _createVNode(_component_v_spacer)
      ]),
      (_ctx.report)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            class: "my-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _cache[70] || (_cache[70] = _createElementVNode("h2", null, "家庭での様子", -1)),
                  _createVNode(_component_v_table, { class: "report-table" }, {
                    default: _withCtx(() => [
                      _cache[69] || (_cache[69] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "text-left" }, "項目"),
                          _createElementVNode("th", { class: "text-left" }, "内容")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[63] || (_cache[63] = _createElementVNode("td", { class: "report-table-header" }, "睡眠時間", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.home.sleeps, (sleep) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: sleep.sleepId
                              }, _toDisplayString(sleep ? _ctx.formatDate(sleep.from) : "") + " ~ " + _toDisplayString(sleep ? _ctx.formatDate(sleep.to) : ""), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[64] || (_cache[64] = _createElementVNode("td", { class: "report-table-header" }, "排便", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.home.defecations, (defecation) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: defecation.defecationId
                              }, [
                                _createElementVNode("span", _hoisted_4, _toDisplayString(defecation ? _ctx.formatDate(defecation.recordedAt) : ""), 1),
                                _createElementVNode("span", _hoisted_5, _toDisplayString(defecation ? _ctx.formatDefecation(defecation.state) : ""), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[65] || (_cache[65] = _createElementVNode("td", { class: "report-table-header" }, "体温", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.home.temperatures, (temperature) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: temperature.temperatureId
                              }, [
                                _createElementVNode("span", _hoisted_6, _toDisplayString(temperature ? _ctx.formatDate(temperature.recordedAt) : ""), 1),
                                _createElementVNode("span", _hoisted_7, _toDisplayString(temperature
                            ? _ctx.formatTemperature(temperature.temperature)
                            : "") + "℃ ", 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[66] || (_cache[66] = _createElementVNode("td", { class: "report-table-header" }, "夕食", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.home.dinners, (dinner) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: dinner.dinnerId
                              }, _toDisplayString(dinner.content), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[67] || (_cache[67] = _createElementVNode("td", { class: "report-table-header" }, "朝食", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.home.breakfasts, (breakfast) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: breakfast.breakfastId
                              }, _toDisplayString(breakfast.content), 1))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[68] || (_cache[68] = _createElementVNode("td", { class: "report-table-header" }, "ミルク", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.home.milks, (milk) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: milk.milkId
                              }, [
                                _createElementVNode("span", _hoisted_8, _toDisplayString(milk ? _ctx.formatDate(milk.recordedAt) : ""), 1),
                                _createElementVNode("span", _hoisted_9, _toDisplayString(milk.amount ? milk.amount.value : "（不明）") + "cc ", 1)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _cache[83] || (_cache[83] = _createElementVNode("h2", null, "園での様子", -1)),
                  _createVNode(_component_v_table, { class: "report-table" }, {
                    default: _withCtx(() => [
                      _cache[82] || (_cache[82] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "text-left" }, "項目"),
                          _createElementVNode("th", { class: "text-left" }, "内容")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[71] || (_cache[71] = _createElementVNode("td", { class: "report-table-header" }, "登園時間", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.attendance ? _ctx.formatDate(_ctx.attendance.attendedAt) : ""), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[72] || (_cache[72] = _createElementVNode("td", { class: "report-table-header" }, "降園時間", -1)),
                          _createElementVNode("td", null, _toDisplayString(_ctx.attendance ? _ctx.formatDate(_ctx.attendance.leftAt) : ""), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[75] || (_cache[75] = _createElementVNode("td", { class: "report-table-header" }, "排便", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.nursery.defecations, (defecation) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: defecation.defecationId
                              }, [
                                _createElementVNode("div", {
                                  class: "d-inline",
                                  onClick: ($event: any) => (_ctx.changeEditDefecation(defecation))
                                }, [
                                  _createElementVNode("span", _hoisted_11, _toDisplayString(defecation ? _ctx.formatDate(defecation.recordedAt) : ""), 1),
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(defecation ? _ctx.formatDefecation(defecation.state) : ""), 1)
                                ], 8, _hoisted_10),
                                (_ctx.report.nursery.defecations.at(-1)?.defecationId == defecation.defecationId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(_component_v_btn, {
                                        size: "x-small",
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeAddOtherRecord('defecation'))),
                                        disabled: _ctx.loading
                                      }, {
                                        default: _withCtx(() => [...(_cache[73] || (_cache[73] = [
                                          _createTextVNode(" +記録を追加 ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            (!_ctx.report.nursery.defecations.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: "outlined",
                                    color: "primary",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeAddOtherRecord('defecation'))),
                                    disabled: _ctx.loading
                                  }, {
                                    default: _withCtx(() => [...(_cache[74] || (_cache[74] = [
                                      _createTextVNode(" +記録を追加 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[78] || (_cache[78] = _createElementVNode("td", { class: "report-table-header" }, "体温", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.nursery.temperatures, (temperature) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: temperature.temperatureId
                              }, [
                                _createElementVNode("div", {
                                  class: "d-inline",
                                  onClick: ($event: any) => (_ctx.changeEditTemperature(temperature))
                                }, [
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(temperature ? _ctx.formatDate(temperature.recordedAt) : ""), 1),
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(temperature
                              ? _ctx.formatTemperature(temperature.temperature)
                              : "") + "℃ ", 1)
                                ], 8, _hoisted_15),
                                (_ctx.report.nursery.temperatures.at(-1)?.temperatureId == temperature.temperatureId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                      _createVNode(_component_v_btn, {
                                        size: "x-small",
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeAddOtherRecord('temperature'))),
                                        disabled: _ctx.loading
                                      }, {
                                        default: _withCtx(() => [...(_cache[76] || (_cache[76] = [
                                          _createTextVNode(" +記録を追加 ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            (!_ctx.report.nursery.temperatures.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: "outlined",
                                    color: "primary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeAddOtherRecord('temperature'))),
                                    disabled: _ctx.loading
                                  }, {
                                    default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                                      _createTextVNode(" +記録を追加 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[81] || (_cache[81] = _createElementVNode("td", { class: "report-table-header" }, "ミルク", -1)),
                          _createElementVNode("td", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.report.nursery.milks, (milk) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: milk.milkId
                              }, [
                                _createElementVNode("div", {
                                  class: "d-inline",
                                  onClick: ($event: any) => (_ctx.changeEditMilk(milk))
                                }, [
                                  _createElementVNode("span", _hoisted_21, _toDisplayString(milk ? _ctx.formatDate(milk.recordedAt) : ""), 1),
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(milk.amount ? milk.amount.value : "（不明）") + "cc ", 1)
                                ], 8, _hoisted_20),
                                (_ctx.report.nursery.milks.at(-1)?.milkId == milk.milkId)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createVNode(_component_v_btn, {
                                        size: "x-small",
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeAddOtherRecord('milk'))),
                                        disabled: _ctx.loading
                                      }, {
                                        default: _withCtx(() => [...(_cache[79] || (_cache[79] = [
                                          _createTextVNode(" +記録を追加 ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["disabled"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128)),
                            (!_ctx.report.nursery.milks.length)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                  _createVNode(_component_v_btn, {
                                    size: "small",
                                    variant: "outlined",
                                    color: "primary",
                                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeAddOtherRecord('milk'))),
                                    disabled: _ctx.loading
                                  }, {
                                    default: _withCtx(() => [...(_cache[80] || (_cache[80] = [
                                      _createTextVNode(" +記録を追加 ", -1)
                                    ]))]),
                                    _: 1
                                  }, 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "4" }, {
                default: _withCtx(() => [
                  _cache[94] || (_cache[94] = _createElementVNode("h2", { class: "d-inline" }, "喫食", -1)),
                  (!_ctx.report.nursery.meal)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                        _createVNode(_component_v_btn, {
                          size: "small",
                          variant: "outlined",
                          color: "primary",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.createMealReport())),
                          disabled: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[84] || (_cache[84] = [
                            _createTextVNode(" +記録を追加 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, [
                        _createVNode(_component_v_btn, {
                          size: "default",
                          variant: "text",
                          color: "primary",
                          height: "20",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.fullEat())),
                          disabled: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[85] || (_cache[85] = [
                            _createTextVNode(" すべて完食 ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled"])
                      ])),
                  _createVNode(_component_v_table, { class: "report-table" }, {
                    default: _withCtx(() => [
                      _cache[93] || (_cache[93] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "text-left" }, "項目"),
                          _createElementVNode("th", { class: "text-left" }, "内容")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[86] || (_cache[86] = _createElementVNode("td", { class: "report-table-header" }, "主食", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.stapleFood)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_27, [
                                _createElementVNode("div", {
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showMenu('stapleFood')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.stapleFood,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showMenuItem.stapleFood) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex" }, props, { style: {"position":"relative"} }), _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.stapleFood)), 17)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('stapleFood', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_28, [
                                                      _createElementVNode("div", _hoisted_29, [
                                                        _createElementVNode("div", _hoisted_30, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_31, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_32, _toDisplayString("")))
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[87] || (_cache[87] = _createElementVNode("td", { class: "report-table-header" }, "主菜", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.mainDish)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_33, [
                                _createElementVNode("div", {
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showMenu('mainDish')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.mainDish,
                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showMenuItem.mainDish) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex flex-column" }, props), [
                                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.mainDish)), 1)
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('mainDish', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_35, [
                                                      _createElementVNode("div", _hoisted_36, [
                                                        _createElementVNode("div", _hoisted_37, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_38, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_39, _toDisplayString("")))
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[88] || (_cache[88] = _createElementVNode("td", { class: "report-table-header" }, "副菜", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.sideDish)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                                _createElementVNode("div", {
                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showMenu('sideDish')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.sideDish,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showMenuItem.sideDish) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex flex-column" }, props), [
                                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.sideDish)), 1)
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('sideDish', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_42, [
                                                      _createElementVNode("div", _hoisted_43, [
                                                        _createElementVNode("div", _hoisted_44, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_45, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_46, _toDisplayString("")))
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[89] || (_cache[89] = _createElementVNode("td", { class: "report-table-header" }, "汁もの", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.soup)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_47, [
                                _createElementVNode("div", {
                                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showMenu('soup')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.soup,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showMenuItem.soup) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex flex-column" }, props), [
                                        _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.soup)), 1)
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('soup', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_49, [
                                                      _createElementVNode("div", _hoisted_50, [
                                                        _createElementVNode("div", _hoisted_51, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_52, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_53, _toDisplayString("")))
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[90] || (_cache[90] = _createElementVNode("td", { class: "report-table-header" }, "デザート", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.dessert)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_54, [
                                _createElementVNode("div", {
                                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showMenu('dessert')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.dessert,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showMenuItem.dessert) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex flex-column" }, props), [
                                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.dessert)), 1)
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('dessert', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_56, [
                                                      _createElementVNode("div", _hoisted_57, [
                                                        _createElementVNode("div", _hoisted_58, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_59, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString("")))
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[91] || (_cache[91] = _createElementVNode("td", { class: "report-table-header" }, "牛乳", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.milk)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_61, [
                                _createElementVNode("div", {
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showMenu('milk')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.milk,
                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.showMenuItem.milk) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex flex-column" }, props), [
                                        _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.milk)), 1)
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('milk', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_63, [
                                                      _createElementVNode("div", _hoisted_64, [
                                                        _createElementVNode("div", _hoisted_65, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_66, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_67, _toDisplayString("")))
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[92] || (_cache[92] = _createElementVNode("td", { class: "report-table-header" }, "おやつ", -1)),
                          (_ctx.report.nursery.meal && _ctx.mealRecord.snack)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_68, [
                                _createElementVNode("div", {
                                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showMenu('snack')))
                                }, [
                                  _createVNode(_component_v_menu, {
                                    modelValue: _ctx.showMenuItem.snack,
                                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.showMenuItem.snack) = $event)),
                                    location: "bottom",
                                    "max-width": "290px"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createElementVNode("div", _mergeProps({ class: "d-flex flex-column" }, props), [
                                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.formatMealStatus(_ctx.mealRecord.snack)), 1)
                                      ], 16)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (s, index) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: index,
                                              onClick: ($event: any) => (_ctx.changeMealStatus('snack', s.status))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_70, [
                                                      _createElementVNode("div", _hoisted_71, [
                                                        _createElementVNode("div", _hoisted_72, [
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-back-${s.status}`)
                                                          }, null, 2),
                                                          _createElementVNode("div", {
                                                            class: _normalizeClass(`circle-front-${s.status}`)
                                                          }, null, 2)
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_73, _toDisplayString(s.title), 1)
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"])
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("td", _hoisted_74, _toDisplayString("")))
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _cache[96] || (_cache[96] = _createElementVNode("h3", null, "活動記録 / 発達状況", -1)),
      _createElementVNode("div", _hoisted_75, [
        (_ctx.diary)
          ? (_openBlock(), _createBlock(_component_v_textarea, {
              key: 0,
              modelValue: _ctx.content,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.content) = $event)),
              variant: "outlined"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_76, [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "outlined",
            class: "",
            onClick: _ctx.saveContent,
            disabled: !_ctx.isSaveContent,
            loading: _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[95] || (_cache[95] = [
              _createTextVNode(" 保存 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "disabled", "loading"])
        ])
      ])
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.addRecordDialog,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.addRecordDialog) = $event)),
      "max-width": "720"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "align-center justify-center" }, {
              default: _withCtx(() => [...(_cache[97] || (_cache[97] = [
                _createTextVNode(" 記録を追加 ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.otherRecord == 'defecation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_77, [
                        _createVNode(_component_v_chip, {
                          color: "#02c07c",
                          variant: "outlined",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[98] || (_cache[98] = [
                            _createTextVNode("排便", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_v_menu, {
                        modelValue: _ctx.isRecordetAtPicker,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.isRecordetAtPicker) = $event)),
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        location: "bottom",
                        "max-width": "290px",
                        "min-width": "290px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            modelValue: _ctx.recordedAt,
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            label: "時間",
                            "prepend-icon": "mdi-clock-time-four-outline",
                            rules: [_ctx.rules],
                            readonly: ""
                          }, props, {
                            variant: "outlined",
                            density: "compact"
                          }), null, 16, ["modelValue", "rules"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isRecordetAtPicker)
                            ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                key: 0,
                                modelValue: _ctx.recordedAt,
                                "onUpdate:modelValue": [
                                  _cache[24] || (_cache[24] = ($event: any) => ((_ctx.recordedAt) = $event)),
                                  _cache[25] || (_cache[25] = (val) => { _ctx.changeRecordedAt(val); _ctx.isRecordetAtPicker = false; })
                                ],
                                "full-width": "",
                                format: "24hr",
                                "allowed-minutes": _ctx.allowedStep
                              }, null, 8, ["modelValue", "allowed-minutes"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.defecation,
                        "onUpdate:modelValue": [
                          _cache[27] || (_cache[27] = ($event: any) => ((_ctx.defecation) = $event)),
                          _ctx.changeDefecationState
                        ],
                        items: _ctx.choices,
                        "item-title": "text",
                        "item-value": "value",
                        rules: [_ctx.rules],
                        label: "状態",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord == 'temperature')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_78, [
                        _createVNode(_component_v_chip, {
                          color: "#eb2121",
                          variant: "outlined",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[99] || (_cache[99] = [
                            _createTextVNode("体温", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_v_menu, {
                        modelValue: _ctx.isRecordetAtPicker,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.isRecordetAtPicker) = $event)),
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        location: "bottom",
                        "max-width": "290px",
                        "min-width": "290px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            modelValue: _ctx.recordedAt,
                            "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            label: "時間",
                            "prepend-icon": "mdi-clock-time-four-outline",
                            rules: [_ctx.rules],
                            readonly: ""
                          }, props, {
                            variant: "outlined",
                            density: "compact"
                          }), null, 16, ["modelValue", "rules"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isRecordetAtPicker)
                            ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                key: 0,
                                modelValue: _ctx.recordedAt,
                                "onUpdate:modelValue": [
                                  _cache[29] || (_cache[29] = ($event: any) => ((_ctx.recordedAt) = $event)),
                                  _cache[30] || (_cache[30] = (val) => { _ctx.changeRecordedAt(val); _ctx.isRecordetAtPicker = false; })
                                ],
                                "full-width": "",
                                format: "24hr",
                                "allowed-minutes": _ctx.allowedStep
                              }, null, 8, ["modelValue", "allowed-minutes"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_79, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.temperature,
                          "onUpdate:modelValue": [
                            _cache[32] || (_cache[32] = ($event: any) => ((_ctx.temperature) = $event)),
                            _ctx.changeTemperature
                          ],
                          items: _ctx.optionsTemperature,
                          "item-title": "text",
                          "item-value": "value",
                          rules: [_ctx.rules],
                          label: "体温",
                          "menu-props": { auto: true },
                          variant: "outlined",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]),
                        _cache[100] || (_cache[100] = _createElementVNode("p", { class: "ml-1 body-1" }, "℃", -1))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord == 'milk')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_80, [
                        _createVNode(_component_v_chip, {
                          color: "#db069f",
                          variant: "outlined",
                          size: "small"
                        }, {
                          default: _withCtx(() => [...(_cache[101] || (_cache[101] = [
                            _createTextVNode("ミルク", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_v_menu, {
                        modelValue: _ctx.isRecordetAtPicker,
                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.isRecordetAtPicker) = $event)),
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        location: "bottom",
                        "max-width": "290px",
                        "min-width": "290px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            modelValue: _ctx.recordedAt,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            label: "時間",
                            "prepend-icon": "mdi-clock-time-four-outline",
                            rules: [_ctx.rules],
                            readonly: ""
                          }, props, {
                            variant: "outlined",
                            density: "compact"
                          }), null, 16, ["modelValue", "rules"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.isRecordetAtPicker)
                            ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                key: 0,
                                modelValue: _ctx.recordedAt,
                                "onUpdate:modelValue": [
                                  _cache[34] || (_cache[34] = ($event: any) => ((_ctx.recordedAt) = $event)),
                                  _cache[35] || (_cache[35] = (val) => { _ctx.changeRecordedAt(val); _ctx.isRecordetAtPicker = false; })
                                ],
                                "full-width": "",
                                format: "24hr",
                                "allowed-minutes": _ctx.allowedStep
                              }, null, 8, ["modelValue", "allowed-minutes"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_81, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.amount,
                          "onUpdate:modelValue": [
                            _cache[37] || (_cache[37] = ($event: any) => ((_ctx.amount) = $event)),
                            _ctx.changeAmount
                          ],
                          items: _ctx.milkChoice,
                          "item-title": "value",
                          "item-value": "id",
                          rules: [_ctx.rules],
                          label: "量",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]),
                        _cache[102] || (_cache[102] = _createElementVNode("p", { class: "ml-1 body-1" }, "cc", -1))
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.milkCategory,
                          "onUpdate:modelValue": [
                            _cache[38] || (_cache[38] = ($event: any) => ((_ctx.milkCategory) = $event)),
                            _ctx.changeMilkCategory
                          ],
                          items: _ctx.optionsMilk,
                          "item-title": "text",
                          "item-value": "value",
                          rules: [_ctx.rules],
                          label: "ミルク",
                          variant: "outlined"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "mt-2 mb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pr-2 pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "#6C6C6C",
                          dark: "",
                          variant: "flat",
                          width: "100%",
                          onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.addRecordDialog = false))
                        }, {
                          default: _withCtx(() => [...(_cache[103] || (_cache[103] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "キャンセル")
                            ], -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "6",
                      class: "pl-1 pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "primary",
                          variant: "flat",
                          width: "100%",
                          onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.save(_ctx.otherRecord))),
                          disabled: !_ctx.isSaveOtherRecord,
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[104] || (_cache[104] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "保存")
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.editRecordDialog,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.editRecordDialog) = $event)),
      "max-width": "720"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "align-center justify-center" }, {
              default: _withCtx(() => [...(_cache[105] || (_cache[105] = [
                _createTextVNode(" 記録を修正・削除 ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                (_ctx.otherRecord == 'defecation')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.defecationRecord)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", null, [
                              _cache[107] || (_cache[107] = _createTextVNode("修正前： ", -1)),
                              _createVNode(_component_v_chip, {
                                color: "#02c07c",
                                variant: "outlined",
                                size: "small"
                              }, {
                                default: _withCtx(() => [...(_cache[106] || (_cache[106] = [
                                  _createTextVNode("排便", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.formatTime(_ctx.defecationRecord?.recordedAt)), 1),
                            _createElementVNode("div", _hoisted_85, _toDisplayString(_ctx.formatDefecation(_ctx.defecationRecord.state)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_menu, {
                        modelValue: _ctx.editRecordAtPicker,
                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.editRecordAtPicker) = $event)),
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        location: "bottom",
                        "max-width": "290px",
                        "min-width": "290px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            modelValue: _ctx.recordedAt,
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            label: "時間",
                            "prepend-icon": "mdi-clock-time-four-outline",
                            rules: [_ctx.rules],
                            readonly: ""
                          }, props, {
                            variant: "outlined",
                            density: "compact"
                          }), null, 16, ["modelValue", "rules"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.editRecordAtPicker)
                            ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                key: 0,
                                modelValue: _ctx.recordedAt,
                                "onUpdate:modelValue": [
                                  _cache[43] || (_cache[43] = ($event: any) => ((_ctx.recordedAt) = $event)),
                                  _cache[44] || (_cache[44] = (val) => { _ctx.changeRecordedAt(val); _ctx.editRecordAtPicker = false; })
                                ],
                                "full-width": "",
                                format: "24hr",
                                "allowed-minutes": _ctx.allowedStep
                              }, null, 8, ["modelValue", "allowed-minutes"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_v_select, {
                        modelValue: _ctx.defecation,
                        "onUpdate:modelValue": [
                          _cache[46] || (_cache[46] = ($event: any) => ((_ctx.defecation) = $event)),
                          _ctx.changeDefecationState
                        ],
                        items: _ctx.choices,
                        "item-title": "text",
                        "item-value": "value",
                        rules: [_ctx.rules],
                        label: "状態",
                        variant: "outlined",
                        density: "compact"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord == 'temperature')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_ctx.temperatureRecord)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                            _createElementVNode("div", null, [
                              _cache[109] || (_cache[109] = _createTextVNode("修正前： ", -1)),
                              _createVNode(_component_v_chip, {
                                color: "#eb2121",
                                variant: "outlined",
                                size: "small"
                              }, {
                                default: _withCtx(() => [...(_cache[108] || (_cache[108] = [
                                  _createTextVNode("体温", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.formatTime(_ctx.temperatureRecord?.recordedAt)), 1),
                            _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.formatTemperature(_ctx.temperatureRecord.temperature)) + "℃", 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_menu, {
                        modelValue: _ctx.editRecordAtPicker,
                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.editRecordAtPicker) = $event)),
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        location: "bottom",
                        "max-width": "290px",
                        "min-width": "290px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            modelValue: _ctx.recordedAt,
                            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            label: "時間",
                            "prepend-icon": "mdi-clock-time-four-outline",
                            rules: [_ctx.rules],
                            readonly: ""
                          }, props, {
                            variant: "outlined",
                            density: "compact"
                          }), null, 16, ["modelValue", "rules"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.editRecordAtPicker)
                            ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                key: 0,
                                modelValue: _ctx.recordedAt,
                                "onUpdate:modelValue": [
                                  _cache[48] || (_cache[48] = ($event: any) => ((_ctx.recordedAt) = $event)),
                                  _cache[49] || (_cache[49] = (val) => { _ctx.changeRecordedAt(val); _ctx.editRecordAtPicker = false; })
                                ],
                                "full-width": "",
                                format: "24hr",
                                "allowed-minutes": _ctx.allowedStep
                              }, null, 8, ["modelValue", "allowed-minutes"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_89, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.temperature,
                          "onUpdate:modelValue": [
                            _cache[51] || (_cache[51] = ($event: any) => ((_ctx.temperature) = $event)),
                            _ctx.changeTemperature
                          ],
                          items: _ctx.optionsTemperature,
                          "item-title": "text",
                          "item-value": "value",
                          rules: [_ctx.rules],
                          label: "体温",
                          "menu-props": { auto: true },
                          variant: "outlined",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]),
                        _cache[110] || (_cache[110] = _createElementVNode("p", { class: "ml-1 body-1" }, "℃", -1))
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.otherRecord == 'milk')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (_ctx.milkRecord)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                            _createElementVNode("div", null, [
                              _cache[112] || (_cache[112] = _createTextVNode("修正前： ", -1)),
                              _createVNode(_component_v_chip, {
                                color: "#db069f",
                                variant: "outlined",
                                size: "small"
                              }, {
                                default: _withCtx(() => [...(_cache[111] || (_cache[111] = [
                                  _createTextVNode("ミルク", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_91, _toDisplayString(_ctx.formatTime(_ctx.milkRecord?.recordedAt)), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.milkRecord)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                            _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.milkRecord.amount?.value) + "cc", 1),
                            (_ctx.milkRecord.milkCategory == 'formula')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_94, "粉ミルク"))
                              : _createCommentVNode("", true),
                            (_ctx.milkRecord.milkCategory == 'breast')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_95, "母乳"))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_menu, {
                        modelValue: _ctx.editRecordAtPicker,
                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.editRecordAtPicker) = $event)),
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        location: "bottom",
                        "max-width": "290px",
                        "min-width": "290px"
                      }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_text_field, _mergeProps({
                            modelValue: _ctx.recordedAt,
                            "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.recordedAt) = $event)),
                            label: "時間",
                            "prepend-icon": "mdi-clock-time-four-outline",
                            rules: [_ctx.rules],
                            readonly: ""
                          }, props, {
                            variant: "outlined",
                            density: "compact"
                          }), null, 16, ["modelValue", "rules"])
                        ]),
                        default: _withCtx(() => [
                          (_ctx.editRecordAtPicker)
                            ? (_openBlock(), _createBlock(_component_v_time_picker, {
                                key: 0,
                                modelValue: _ctx.recordedAt,
                                "onUpdate:modelValue": [
                                  _cache[53] || (_cache[53] = ($event: any) => ((_ctx.recordedAt) = $event)),
                                  _cache[54] || (_cache[54] = (val) => { _ctx.changeRecordedAt(val); _ctx.editRecordAtPicker = false; })
                                ],
                                "full-width": "",
                                format: "24hr",
                                "allowed-minutes": _ctx.allowedStep
                              }, null, 8, ["modelValue", "allowed-minutes"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_96, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.amount,
                          "onUpdate:modelValue": [
                            _cache[56] || (_cache[56] = ($event: any) => ((_ctx.amount) = $event)),
                            _ctx.changeAmount
                          ],
                          items: _ctx.milkChoice,
                          "item-title": "value",
                          "item-value": "id",
                          rules: [_ctx.rules],
                          label: "量",
                          variant: "outlined",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"]),
                        _cache[113] || (_cache[113] = _createElementVNode("p", { class: "ml-1 body-1" }, "cc", -1))
                      ]),
                      _createElementVNode("div", _hoisted_97, [
                        _createVNode(_component_v_select, {
                          modelValue: _ctx.milkCategory,
                          "onUpdate:modelValue": [
                            _cache[57] || (_cache[57] = ($event: any) => ((_ctx.milkCategory) = $event)),
                            _ctx.changeMilkCategory
                          ],
                          items: _ctx.optionsMilk,
                          "item-title": "text",
                          "item-value": "value",
                          rules: [_ctx.rules],
                          label: "ミルク",
                          variant: "outlined",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "rules"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, { class: "mt-2 mb-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pr-2 pl-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "#6C6C6C",
                          dark: "",
                          variant: "flat",
                          width: "100%",
                          onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.editRecordDialog = false))
                        }, {
                          default: _withCtx(() => [...(_cache[114] || (_cache[114] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "キャンセル")
                            ], -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pl-1 pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "error",
                          variant: "outlined",
                          width: "100%",
                          onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.remove(_ctx.otherRecord))),
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[115] || (_cache[115] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "text-body-2 font-weight-bold message-btn" }, "削除")
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["loading"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "4",
                      class: "pl-1 pr-2"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          class: "",
                          color: "primary",
                          variant: "flat",
                          width: "100%",
                          onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.change(_ctx.otherRecord))),
                          disabled: !_ctx.isSaveOtherRecord,
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[116] || (_cache[116] = [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "text-h6 font-weight-bold message-btn" }, "保存")
                            ], -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "loading"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}